import { FormInput } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { InputLabel, styled } from '@mui/material';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { BusinessGroupInfoFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

const StyleFormInput = styled(FormInput)({
  '.MuiFormLabel-root': {
    fontSize: '0.625rem',
  },
});

const ProductCharacterFormFields = ({
  marketPolicyIndex: index,
}: {
  marketPolicyIndex: number;
}) => {
  const { setValue } = useNatureOfBusinessForm();
  const { nameTh = '', nameEn = '' } =
    useWatch({
      name: `productInformation.businessGroupInfos.${index}`,
    }) ?? ({} as BusinessGroupInfoFormValues);

  useEffect(() => {
    setValue(
      `marketingIndustry.marketingPolicy.${index}.productNameTh`,
      nameTh
    );
    setValue(
      `marketingIndustry.marketingPolicy.${index}.productNameEn`,
      nameEn
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameEn, nameTh]);

  return (
    <>
      <InputLabel required>กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ</InputLabel>
      <StyleFormInput
        name={`marketingIndustry.marketingPolicy.${index}.productNameTh`}
        placeholder={'กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ (ไทย)'}
        label={'ภาษาไทย'}
        fullWidth
        sx={{ ...disabledFormInputStyles, mt: 1.5 }}
      />
      <StyleFormInput
        name={`marketingIndustry.marketingPolicy.${index}.productNameEn`}
        placeholder={'กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ (อังกฤษ)'}
        label={'ภาษาอังกฤษ'}
        fullWidth
        sx={{ ...disabledFormInputStyles, mt: 2 }}
      />
    </>
  );
};

export default ProductCharacterFormFields;
